export const getJobListQuery = `
query GetAllJobs {
    getAllJobs {
        id
        title
        postingDate
        totalPay
        jobLocation
        jobRole
        jobLevel
        duration
        postingStatus
        jobType
        hiringManager
        briefText
        currencyCode
    }
}
`;

export const getJobListWithFiltersQuery = `
query GetAllJobsWithFilter($input: JobFilterInput!) {
    getAllJobsWithFilter(input: $input) {
        id
        title
        postingDate
        totalPay
        jobLocation
        jobRole
        jobLevel
        duration
        currencyCode
        hiringManager
    }
}
`;

export const getJobByIdQuery = `
query GetJobById($input: ID!) {
    getJobById(id: $input) {
        id
        title
        description
        postingDate
        totalPay
        postingStatus
        jobLocation
        jobImage
        jobRole
        jobLevel
        jobType
        duration
        preferredStartDate
        briefText
        currencyCode
        hiringManager
    }
}
`;

export const createJobQuery = `
mutation CreateJob($input: CreateJobInput!, $file: Upload!) {
    createJob(input: $input, file: $file) {
        id
        title
        description
        postingDate
        totalPay
        postingStatus
        jobLocation
        jobImage
        jobRole
        jobLevel
        jobType
        duration
        preferredStartDate
        briefText
        currencyCode
        hiringManager
    }
}
`;

export const updateJobQuery = `
mutation UpdateJob($input: UpdateJobInput!, $file: Upload) {
    updateJob(input: $input, file: $file) {
        id
        title
        description
        postingDate
        totalPay
        postingStatus
        jobLocation
        jobImage
        jobRole
        jobLevel
        jobType
        duration
        preferredStartDate
        briefText
        currencyCode
        hiringManager
    }
}
`;
